<template>
    <svg :class="`icon icon-${icon}`">
        <use :href="svgUrl" :xlink:href="svgUrl" />
    </svg>
</template>

<script>
    export default {
        name: 'Icon',
        computed: {
            svgUrl() {
                return `/app/themes/rugby/dist/svg/sprite.symbol.svg#${this.icon}`;
            },
        },
        props: {
            icon: {
                required: true,
                type: String,
            },
        },
    };
</script>
